module.exports = __webpack_public_path__ + "static/media/astronomy_02.cd8e5e7a.jpg";